import React from "react";
import { Stack, Paper, Skeleton, Box } from "@mui/material";

const TransactionsTableSkeleton = ({ rows = 3 }) => {
  return (
    <Stack spacing={3}>
      {Array.from({ length: rows }).map((_, index) => (
        <Paper key={index} sx={{ borderRadius: 2, overflow: "hidden" }}>
          {/* Header Skeleton */}
          <Box sx={{ p: 2, bgcolor: "grey.50" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Skeleton width={200} height={24} />
              <Box display="flex" gap={2} alignItems="center">
                <Skeleton width={100} height={32} />
                <Skeleton width={80} height={28} variant="rounded" />
              </Box>
            </Box>
          </Box>

          {/* Table Rows Skeleton */}
          <Box sx={{ p: 2 }}>
            <Stack spacing={1.5}>
              {Array.from({ length: 5 }).map((_, idx) => (
                <Box key={idx} display="flex" gap={2}>
                  <Skeleton width="20%" height={40} />
                  <Skeleton width="20%" height={40} />
                  <Skeleton width="30%" height={40} />
                  <Skeleton width="15%" height={40} />
                  <Skeleton width="15%" height={40} variant="rounded" />
                </Box>
              ))}
            </Stack>
          </Box>

          {/* Button Skeleton */}
          <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Skeleton width={120} height={36} variant="rounded" />
            <Skeleton width={240} height={36} variant="rounded" />
          </Box>
        </Paper>
      ))}
    </Stack>
  );
};

export default TransactionsTableSkeleton;
